

export function readCart(callbackFunction) {
    let cartObject = localStorage.getItem('cart');
    if (cartObject) {
        cartObject = JSON.parse(cartObject);
    }
    callbackFunction(cartObject);
}

export function readPurchasedCart(callbackFunction) {
    let cartObject = localStorage.getItem('purchased_cart');
    if (cartObject) {
        cartObject = JSON.parse(cartObject);
    }
    callbackFunction(cartObject);
}

export function convertCartToPurchaseData() {
    // Migrates the cart data to purchased_cart and clears cart from localStorage
    let cartObject = localStorage.getItem('cart');
    if (cartObject) {
        cartObject = JSON.parse(cartObject);
    }
    localStorage.setItem('purchased_cart', JSON.stringify(cartObject));
    writeCart(null)
}

export function addCartItem(cartItem, isDiscountItem=false) {
    readCart((currentCartData) => {
        if (isDiscountItem) {
            return
        }

        let tempCart = currentCartData || {}
        let tempLineItems = tempCart.productLineItems || []
        tempLineItems.push(cartItem)
        tempCart.productLineItems = tempLineItems
        writeCart(tempCart)
    })
}

export function removeCartItem(itemID, isDiscountItem, callbackFunction) {
    readCart((currentCartData) => {
        if (isDiscountItem) {
            return
        }

        let tempCart = currentCartData || {}
        let tempLineItems = tempCart.productLineItems || []
        tempCart.productLineItems = tempLineItems.filter(item => item.productIndex !== itemID)
        writeCart(tempCart)
        if (callbackFunction) {
            callbackFunction(tempCart)
        }
    })
}

export function saveCheckoutForm(formData) {
    readCart((currentCartData) => {
        let tempCart = currentCartData || {}
        tempCart.checkout_form_data = formData
        writeCart(tempCart)
    })
}

export function writeCart(cartObject) {
    localStorage.setItem('cart', JSON.stringify(cartObject));
}

